/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StaticAggregate {
    COUNT = 'Count',
    COUNT_DISTINCT = 'CountDistinct',
    AVG = 'Avg',
    SUM = 'Sum',
    MIN = 'Min',
    MAX = 'Max',
}
